import { getAcceptLanguage } from './acceptLanguage';

export function localizeField(value, language) {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value !== 'object') return '';

  const lang = getAcceptLanguage(language);
  return (
    value[lang] ??
    value.ku ??
    value.ar ??
    value.en ??
    Object.values(value).find((entry) => typeof entry === 'string' && entry.trim()) ??
    ''
  );
}

export function extractOrders(json) {
  if (Array.isArray(json)) return json;
  if (Array.isArray(json?.data)) return json.data;
  if (Array.isArray(json?.orders)) return json.orders;
  if (Array.isArray(json?.data?.orders)) return json.data.orders;
  if (Array.isArray(json?.data?.data)) return json.data.data;
  if (json?.data && typeof json.data === 'object' && !Array.isArray(json.data) && json.data.id != null) {
    return [json.data];
  }
  if (json && typeof json === 'object' && json.id != null && (json.items || json.total_amount != null)) {
    return [json];
  }
  return [];
}

function mapOrderItems(items, language) {
  if (!Array.isArray(items)) return [];
  return items.map((item) => {
    const product = item.product ?? {};
    const name = localizeField(item.name ?? item.product_name ?? product.name, language);
    const quantity = Number(item.quantity ?? 1) || 1;
    const unitPrice = item.price ?? product.price ?? null;
    const unitDiscount = item.discount ?? product.discount ?? null;
    const lineDescription =
      typeof item.description === 'string' ? item.description : localizeField(item.description, language);

    return {
      id: item.id ?? product.id ?? null,
      name,
      quantity,
      price: unitPrice,
      discount: unitDiscount,
      description: lineDescription || item.note || '',
      lineTotal:
        unitPrice != null && Number.isFinite(Number(unitPrice)) ? Number(unitPrice) * quantity : null,
    };
  });
}

export function mapOrder(order, language) {
  const items = mapOrderItems(order.items ?? order.order_items ?? order.products ?? [], language);
  const names = items
    .map((item) => {
      if (!item.name) return null;
      return item.quantity > 1 ? `${item.name} ×${item.quantity}` : item.name;
    })
    .filter(Boolean);

  const city = order.city ?? null;
  const cityName = localizeField(city?.name ?? order.city_name, language);

  return {
    id: String(order.id ?? order.order_id ?? ''),
    number: order.order_number ?? order.number ?? (order.id != null ? `#${order.id}` : ''),
    serviceId: order.service_id ?? order.serviceId ?? null,
    status: order.status ?? order.state ?? '',
    createdAt: order.created_at ?? order.date ?? order.createdAt ?? order.human_date ?? null,
    humanDate: order.human_date ?? null,
    total:
      order.total_amount ?? order.total ?? order.grand_total ?? order.amount ?? order.price ?? null,
    deliveryPrice: order.delivery_price ?? city?.delivery_price ?? null,
    discountPercent: order.discount_percent ?? null,
    discountAmount: order.discount_amount ?? null,
    cityName: cityName || null,
    cityId: city?.id ?? order.city_id ?? null,
    location: order.location ?? null,
    items,
    itemCount:
      items.reduce((sum, item) => sum + (item.quantity || 0), 0) ||
      Number(order.items_count ?? order.products_count ?? 0) ||
      names.length,
    itemsSummary: names.join('، '),
    deliveryType: order.delivery_type ?? order.service_type ?? null,
    note: order.note ?? order.notes ?? null,
  };
}
